import ENV from "config/Env";
import { localQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { Dealer, DealerLocation } from "models";

const component = "DealersAndLocationsDropdown";

export type DealersListResp = {
  dealers: Dealer[];
  holding_dealers?: Dealer[];
};

export const DealersAndLocationsDropdownKeys = {
  dealers: permanentBackendQueryKey<DealersListResp>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/dealers/list", params: { embed: "dealer_location" } }),
  selectedDealer: localQueryKey<Dealer | null>({ component, data: "selectedDealer" }),
  selectedLocation: localQueryKey<DealerLocation | null>({ component, data: "selectedLocation" }),
  isAllLocationsSelected: localQueryKey<boolean>({ component, data: "isAllLocationsSelected" }),
  allLocationsSelectedDealerId: localQueryKey<number>({ component, data: "allLocationsSelectedDealerId" })
};
